import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompendiumComponent } from '../compendium/compendium.component';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService, ConstantService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { CompendiumService } from '../compendium.service';
import { Compendium } from '../compendium';
import { Locations } from '@app/_helpers/constants';
import { PropertyCompendiumComponent } from '../property-compendium/property-compendium.component';
import { ViewPropertyCompendiumComponent } from '@app/_components/view-compendium/property-view-compendium.component';

@Component({
    selector: 'app-compendium-list',
    templateUrl: './compendium-list.component.html',
    styleUrls: ['./compendium-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class CompendiumListComponent implements OnInit {
	locations: any[] = [];
	constructor(
		private compendiumService: CompendiumService,
		private alertService: AlertService,
		private constantService: ConstantService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = compendiumService.statuses;
		this.locations = this.constantService.locations;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	compendiums: any;
	compendium: Compendium;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = false;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'compendiumId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.compendiumId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-compendium-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.compendiumService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.loading = false;
						this.recordTotal = res.page.recordTotal;
						this.compendiums = res.data.compendiums;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						this.loading = false;
						console.log('compendiums list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);
		} catch (error) {
			this.loading = false;
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(compendium: Compendium) {
		try {
			this.formLoading = true;
			this.compendiumService.update(compendium)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.compendiums.map((compendium, i) => {
							if (compendium.compendiumId === res.data.compendium.compendiumId) {
								this.compendiums[i] = res.data.compendium;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(compendium: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(compendium));

			this.formLoading = true;
			this.compendiumService.delete(compendium.compendiumId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.compendiums.splice(this.compendiums.indexOf(compendium), 1);
						this.recordTotal = this.compendiums.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Compendium ' + compendium.compendiumId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Compendium ' + compendium.compendiumId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "95vw";
		dialogConfig.width = "90vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Compendium'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(CompendiumComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.addCompendiumCB(data);
				
				this.reloadPage();
				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(compendium: Compendium) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "95vw";
		dialogConfig.width = "90vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			compendium: compendium,
			title: 'Edit Compendium'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(CompendiumComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.reloadPage();

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.reloadPage();

				// close the dialogBox
				dialogRef.close();
			});
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenPropertyCompendium() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "95vw";
		dialogConfig.width = "90vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Property Compendium'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertyCompendiumComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.addCompendiumCB(data);
				
				this.reloadPage();
				// close the dialogBox
				dialogRef.close();
			});
	}

	onOpenPropertyViewCompendium() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "95vw";
		dialogConfig.width = "90vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'View Property Compendium'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ViewPropertyCompendiumComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.addCompendiumCB(data);
				
				this.reloadPage();
				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addCompendiumCB(compendium: Compendium) {
		console.log('Adding Compendium: ' + JSON.stringify(compendium));
		// if we don't have a compendiums array yet...
		if (!this.compendiums) {
			this.compendiums = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.compendiums.unshift(compendium);

		// no idea what this is but it is required to update the array
		this.compendiums = [...this.compendiums];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Compendium ' + compendium.compendiumId + ' Added', life: 3000 });
	}

	updateCompendiumCB(compendium: Compendium) {
		console.log('Updating Compendium: ' + JSON.stringify(compendium));
		let itemIndex = this.compendiums.findIndex((item: any) => item.compendiumId === compendium.compendiumId);
		this.compendiums[itemIndex] = compendium;

		// no idea what this is but it is required to update the array
		this.compendiums = [...this.compendiums];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Compendium ' + compendium.compendiumId + ' Updated', life: 3000 });
	}

	deleteCompendiumCB(compendium: Compendium) {
		console.log('Removing Compendium: ' + compendium);
		this.compendiums.splice(this.compendiums.indexOf(compendium), 1);
		this.recordTotal = this.compendiums.length;

		// no idea what this is but it is required to update the array
		this.compendiums = [...this.compendiums];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Compendium ' + compendium.compendiumId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.compendiums ? this.first === (this.compendiums.length - this.rows) : true; }
	isFirstPage(): boolean { return this.compendiums ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(compendium: any) {
		if (compendium?.status) {
			const status = this.statuses.find((e: any) => e.value == compendium.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	get Locations() {
		return Locations;
	}
}
